import { render, staticRenderFns } from "./HomeSass.vue?vue&type=template&id=a5472860&"
import script from "./HomeSass.vue?vue&type=script&lang=js&"
export * from "./HomeSass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports